import { getAPI } from "./axios-base";
import { Product } from "@/models/Product";

interface GetProductsParams {
  name: string;
  value: string;
  supplier: string;
  category: string;
  price: string;
}
export default class RestResourceProduct {
  getProducts(params: GetProductsParams) {
    return getAPI.get(`api/rest/v1/product`, { params });
  }
  getProduct(id: string) {
    return getAPI.get(`api/rest/v1/product/${id}`);
  }
  getProductByCode(code: string) {
    return getAPI.get(`api/rest/v1/product/by-code/${code}`);
  }

  postProduct(product: Product) {
    return getAPI.post("api/rest/v1/product", product);
  }
  enableProduct(id: string, enable: boolean) {
    return getAPI.put(
      `api/rest/v1/product/enable-product/${id}?enabled=${enable}`
    );
  }
  putProduct(id: string, product: any) {
    return getAPI.put(`api/rest/v1/product/${id}`, product);
  }
  deleteProduct(id: string) {
    return getAPI.delete(`api/rest/v1/product/${id}`);
  }
}
